import Proveidor from "../../model/menudesign/Proveidor";

const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteProveidors = async ( proveidor: Proveidor , page : string, id_usu_log : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/proveidors/${id_usu_log}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(proveidor)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
